import { decode } from "@gandlaf21/bolt11-decode";
import * as Sentry from "@sentry/react";

export const validateLightningNodeURI = (uri: string) => {
  const regex = /^[a-fA-F0-9]{66}@[a-zA-Z0-9.-]+:\d{4,5}$/;
  if (uri && !regex.test(uri)) {
    return "Invalid URI format. Ensure it follows the pattern.";
  }
  return "";
};

export const validateInvoice = (invoice: string) => {
  // Simple regex to check if the invoice starts with 'ln' and contains alphanumeric characters
  const lightningInvoiceRegex = /^ln[a-z0-9]+$/i;
  if (!(lightningInvoiceRegex.test(invoice) && invoice.length >= 20)) {
    return false;
  }
  try {
    const decoded = decode(invoice);
    console.log("decoded", decoded);
    return true;
  } catch (e) {
    console.log("could not decode invoice", e);
    Sentry.captureException(e, {
      tags: {
        function: "isValidInvoice",
        action: "invoice_validation",
      },
      contexts: {
        validation_details: {
          invoice: invoice,
          invoiceLength: invoice?.length || 0,
          invoicePrefix: invoice?.substring(0, 10) || "",
        },
      },
    });
    return false;
  }
};
